export enum Sections {
  Sort = 'Sort',
  Dates = 'Dates',
  CustomFilters = 'CustomFilters',
}
